<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-12">
                                <div class="pull-left">
                                    <h4 class="card-title float-left" v-if="expert2.id">
                                        {{$t('expert2.titleEAppraisalAssetView')}}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                <div role="tablist">
                                    <div class="row">
                                        <div class="col-12">
                                            <div block v-b-toggle.expert2-obj class="all-btn add-btn text-uppercase w-100">
                                                <span style="white-space: normal">Баҳолаш объекти маълумотлари</span>
                                            </div>
                                            <b-collapse v-model="visibleObj" id="expert2-obj" accordion="expert2-accordion" role="tabpanel" class="mt-3">
                                                <div class="row">
                                                    <div class="col-lg-6">
                                                        <div class="form-group">
                                                            <label>{{$t('expert2.field.owner')}}</label>
                                                            <div class="form-control">
                                                                <div v-if="expert2 && expert2.ownerClient">
                                                                    <strong>{{ expert2.ownerClient.fullName }}</strong>
                                                                    <span> - {{ expert2.ownerClient.firmName }} </span>
                                                                    <span class="badge badge-primary" v-if="expert2.ownerClient.type === 'Legal'"> Юридик шахс</span>
                                                                    <span class="badge badge-primary" v-else> Жисмоний шахс</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>{{$t('expert2.field.name')}}</label>
                                                            <div class="form-control">
                                                                <span>{{expert2.name}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>{{$t("expert2.field.evlGoalType")}}</label>
                                                            <div class="form-control">
                                                                <span v-if="expert2.evlGoalType">{{expert2.evlGoalType.typeName}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>Банк ходими телефон рақами</label>
                                                            <div class="form-control">
                                                                <span>{{expert2.bankPhone}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-6">
                                                        <div class="form-group">
                                                            <label>{{$t("expert2.field.province")}}</label>
                                                            <div class="form-control">
                                                                <span>{{expert2.province.name}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>{{$t("expert2.field.region")}}</label>
                                                            <div class="form-control">
                                                                <span>{{expert2.region.name}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>{{$t("realEstate.field.microRegion")}}</label>
                                                            <div class="form-control">
                                                                <span>{{expert2.region.name}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label>{{$t('expert2.field.address')}}</label>
                                                            <div class="form-control">
                                                                <span>{{expert2.address}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <div block v-b-toggle.expert2-doc class="all-btn add-btn text-uppercase w-100">
                                                <span style="white-space: normal">{{$t('expert2.field.documents')}}</span>
                                            </div>
                                            <b-collapse v-model="visibleDoc" id="expert2-doc" accordion="expert2-accordion" role="tabpanel" class="scroll">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="section-header">
                                                            <h4>{{$t("expert2.field.docsToSubmit")}}</h4>
                                                        </div>
                                                        <div class="form-group">
                                                            <PreviewDropZone code="reportDropZone"
                                                                             label="expert2.field.docReport"
                                                                             :data="expert2.report"
                                                                             @change="(files) => {expert2.report = files}"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <b-tabs>
                                                            <b-tab :title="$t('realEstate.name')" :title-link-class="{red: ($v.expert2.cadastre.$error || $v.expert2.photos.$error)}" active>
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <div class="form-group">
                                                                            <PreviewDropZone code="cadastreDropZone"
                                                                                             label="expert2.field.docCadastre"
                                                                                             :data="expert2.cadastre"
                                                                                             @change="(files) => {expert2.cadastre = files}"
                                                                            />
                                                                            <div v-if="$v.expert2.cadastre.$error" class="red">{{$t('realEstate.field.docCadastre')}}</div>
                                                                        </div>
                                                                        <div class="form-group">
                                                                            <PreviewDropZone code="buildingDropZone"
                                                                                             label="expert2.field.docPhotos"
                                                                                             :data="expert2.photos"
                                                                                             @change="(files) => {expert2.photos = files}"
                                                                            />
                                                                            <div v-if="$v.expert2.photos.$error" class="red">{{$t('realEstate.field.docBuildingPhotos')}}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </b-tab>
                                                            <b-tab :title="$t('auto.label')" :title-link-class="{red: ($v.expert2.texPassportFiles.$error || $v.expert2.autoPhotos.$error)}">
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <div class="form-group">
                                                                            <PreviewDropZone code="texPassportDropZone"
                                                                                             label="auto.texPassport"
                                                                                             :data="expert2.texPassportFiles"
                                                                                             @change="(files) => {expert2.texPassportFiles = files}"
                                                                            />
                                                                            <div v-if="$v.expert2.texPassportFiles.$error" class="red">{{$t('auto.texPassport')}}</div>
                                                                        </div>
                                                                        <div class="form-group">
                                                                            <PreviewDropZone code="autoImageDropZone"
                                                                                             label="auto.photos"
                                                                                             :data="expert2.autoPhotos"
                                                                                             @change="(files) => {expert2.autoPhotos = files}"
                                                                            />
                                                                            <div v-if="$v.expert2.autoPhotos.$error" class="red">{{$t('auto.photos')}}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </b-tab>
                                                            <b-tab :title="$t('fitment.label')" :title-link-class="{red: $v.expert2.fitmentPictures.$error}">
                                                                <div class="row">
                                                                    <div class="col-12">
                                                                        <div class="form-group">
                                                                            <PreviewDropZone code="fitmentTexPassports"
                                                                                             label="fitment.texPassport"
                                                                                             :data="expert2.fitmentTexPassports"
                                                                                             @change="(files) => {expert2.fitmentTexPassports = files}"
                                                                            />
                                                                        </div>
                                                                        <div class="form-group">
                                                                            <PreviewDropZone code="fitmentImageDropZone"
                                                                                             label="fitment.photos"
                                                                                             :data="expert2.fitmentPictures"
                                                                                             @change="(files) => {expert2.fitmentPictures = files}"
                                                                            />
                                                                            <div v-if="$v.expert2.fitmentPictures.$error" class="red">{{$t('fitment.photos')}}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </b-tab>
                                                        </b-tabs>
                                                    </div>
                                                </div>
                                            </b-collapse>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-12 col-md-6">
                                        <div class="form-group">
                                            <label>{{$t("report.field.agents")}} <span class="red">*</span></label>
                                            <v-select v-model="expert2.agent" label="text"
                                                      :options="agents"
                                                      :filterable="false"
                                                      @search="onUsersSearch"
                                                      @search:focus="onUsersFocus">
                                                <template slot="option" slot-scope="option" v-if="option">
                                                    <div v-html="option.name"></div>
                                                </template>
                                                <template slot="selected-option"
                                                          v-if="expert2.agent && expert2.agent.name">
                                                    <div v-html="expert2.agent.name"
                                                         @click="$eventBus.$emit('search:focus')"></div>
                                                </template>
                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                            </v-select>
                                            <div class="red" v-if="$v.expert2.agent.id.$error">
                                                {{$t("realEstate.field.agent")}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6" v-if="expert2 && expert2.assetCoordination">
                                        <div :class="{invalid : $v.expert2.objects.$error}">
                                            <div class="row">
                                                <div class="col-12">
                                                    <label>{{$t('expert2.field.assetEvaluations')}} <span class="red"> *</span></label>
                                                </div>
                                                <div class="col-12">
                                                    <div class="form-check pl-0 checkbox-inline">
                                                        <label class="form-check-label"
                                                               style="padding-left:22px !important">
                                                            <input class="form-check-input" type="checkbox"
                                                                   v-model="expert2.assetCoordination.hasRealEstate"
                                                            >
                                                            <span class="form-check-sign"></span>
                                                            {{$t("realEstate.name")}}
                                                        </label>
                                                    </div>
                                                    <div class="form-check checkbox-inline">
                                                        <label class="form-check-label">
                                                            <input class="form-check-input" type="checkbox"
                                                                   v-model="expert2.assetCoordination.hasAuto"
                                                            >
                                                            <span class="form-check-sign"></span>
                                                            {{$t("auto.label")}}
                                                        </label>
                                                    </div>
                                                    <div class="form-check checkbox-inline">
                                                        <label class="form-check-label">
                                                            <input class="form-check-input" type="checkbox"
                                                                   v-model="expert2.assetCoordination.hasFitment"
                                                            >
                                                            <span class="form-check-sign"></span>
                                                            {{$t("fitment.label")}}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12">
                                <div class="text-center">
                                    <button class="btn btn-primary"
                                            v-if="isPending && hasPermission('E_BAHOLASH_EXPERT2_ASSET_SAVE')"
                                            @click="onSave"
                                            :disabled="processing"
                                    >
                                        <i class="fa fa-save"></i>
                                        {{$t("action.save")}}
                                    </button>
                                    <button class="btn btn-success ml-2"
                                            v-if="isPending && hasPermission('E_BAHOLASH_EXPERT2_ASSET_BIND_AGENT')"
                                            @click="onPending"
                                            :disabled="processing"
                                    >
                                        <i class="fa fa-check"></i>
                                        {{$t("expert2.action.pending")}}
                                    </button>
                                    <button class="btn btn-danger ml-2"
                                            v-if="hasPermission('E_BAHOLASH_EXPERT2_REJECT') && canReject"
                                            @click="onReject"
                                    >
                                        <i class="fa fa-reply"></i>
                                        {{$t("expert2.action.reject")}}
                                    </button>
                                    <button class="btn btn-default ml-2" @click="cancel" :disabled="processing">
                                        {{$t("action.cancel")}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <expert2-reject-comment />
    </div>
</template>

<script>

    import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
    import { VBToggle } from 'bootstrap-vue/es/directives/toggle/toggle'
    import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
    import {requiredUnless, minLength} from 'vuelidate/lib/validators';
    import initFilterModel from '@/shared/filter';
    import Expert2RejectComment from '@/components/Expert2RejectComment';
    import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
    import bTab from 'bootstrap-vue/es/components/tabs/tab';

    export default {
        components: {
            BCollapse,
            PreviewDropZone,
            Expert2RejectComment,
            'b-tabs': bTabs,
            'b-tab': bTab,
        },
        directives: {
            'b-toggle': VBToggle
        },
        data() {
            return {
                processing: false,
                loading: false,
                filter: initFilterModel(),
                expert2: {
                    id: null,
                    organizationName: '',
                    ownerClient: null,
                    approachCost: false,
                    approachIncome: false,
                    approachComparative: false,
                    name: '',
                    province: {},
                    region: {},
                    address: '',
                    evlGoalType: null,
                    clientReportNumber: '',
                    evlEstimatedDate: null,
                    realEstate: {},
                    cadastre: [],
                    report: [],
                    photos: [],
                    microRegionId: null,
                    cadastreDocNumber: '',
                    isOrganization: false,
                    isReportNumDate: false,
                    isReportDoc: false,
                    isCadDocument: false,
                    isPhotos: false,
                    buildingCount: 0,
                    buildingType: {},
                    agent: {},
                    texPassportFiles: [],
                    autoPhotos: [],
                    fitmentTexPassports: [],
                    fitmentPictures: [],
                    assetCoordination: {}
                },
                realEstate: {},
                buildingTypes: [],
                agents: [],
                visibleObj: true,
                visibleDoc: false
            }
        },
        validations() {
            return {
                expert2: {
                    agent: {
                        id: {
                            required: requiredUnless(() => {
                                return !this.isPending
                            })
                        }
                    },
                    cadastre: {
                        required: requiredUnless(() => {
                            return !this.hasRealEstateField
                        }),
                        minLength: minLength(1)
                    },
                    photos: {
                        required: requiredUnless(() => {
                            return !this.hasRealEstateField
                        }),
                        minLength: minLength(1)
                    },
                    texPassportFiles: {
                        required: requiredUnless(() => {
                            return !this.hasAutoField
                        }),
                        minLength: minLength(1)
                    },
                    autoPhotos: {
                        required: requiredUnless(() => {
                            return !this.hasAutoField
                        }),
                        minLength: minLength(1)
                    },
                    fitmentPictures: {
                        required: requiredUnless(() => {
                            return !this.hasFitmentField
                        }),
                        minLength: minLength(1)
                    },
                    objects: {
                        required: requiredUnless(() => {
                            return !(!this.hasObject);
                        })
                    }
                }
            }
        },
        computed: {
            isPending() {
                return this.expert2.status === 'Pending';
            },
            canReject() {
                return this.hasPermission('E_BAHOLASH_EXPERT2_REJECT') && this.expert2.status === 'Pending';
            },
            hasObject() {
                return this.expert2.assetCoordination && (this.expert2.assetCoordination.hasRealEstate || this.expert2.assetCoordination.hasAuto || this.expert2.assetCoordination.hasFitment)
            },
            hasRealEstateField() {
                return this.expert2.assetCoordination.hasRealEstate;
            },
            hasAutoField() {
                return this.expert2.assetCoordination.hasAuto
            },
            hasFitmentField() {
                return this.expert2.assetCoordination.hasFitment
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                if (id && id > 0) {
                    this.loading = true;

                    this.$http.get(`expert2/${id}`)
                        .then(res => {
                            vm.expert2 = res.data;
                            this.loading = false;
                        }, () => {
                            this.loading = false;
                        })
                }
            },
            onSave() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.processing = true;

                this.$http.post('admin/expert2/save', this.expert2)
                    .then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.expert2.statusSuccess'),
                                type: 'success'
                            });
                            this.$router.push('/e-appraisal/expert2/asset/list')
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.expert2.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    })
            },
            onPending() {
                this.$v.$touch();

                let validDoc = this.$v.expert2.cadastre.$error || this.$v.expert2.photos.$error
                                || this.$v.expert2.texPassportFiles.$error || this.$v.expert2.autoPhotos.$error
                                || this.$v.expert2.fitmentPictures.$error
                if (validDoc) {
                    this.visibleDoc = true
                }

                if (this.$v.$invalid) {
                    return;
                }

                this.processing = true;

                this.$http.post('admin/e-appraisal/expert2/bind-agent',this.expert2)
                    .then(res => {
                        if (res.data && res.data.code === 'DENIED') {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.expert2.validate'),
                                type: 'error'
                            });
                        } else if (res.data && res.data.status === 'SUCCESS') {
                            this.$router.push('/e-appraisal/expert2/asset/list')
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.expert2.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    })
            },
            onReject() {
                this.$eventBus.$emit('Expert2RejectComment', this.expert2.id, false, "Expert2", true);
            },
            cancel() {
                this.$router.push('/e-appraisal/expert2/real-estate/list')
            },
            onBuildingFocus() {
                this.buildingTypes = [];
                this.$http.get('uy-joy-api/categories/list')
                    .then(res => {
                        if (res.data !== "" && res.data.data.length > 0) {
                            this.buildingTypes = res.data.data;
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            onUsersSearch(searchTxt, loading) {
                loading(true);
                this.agents = [];
                this.filter.search = searchTxt;

                this.filter.province = null;
                this.filter.region = null;

                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.agents = res.data.data;
                        loading(false);
                        this.filter.search = '';
                    }, err => {
                        console.log(err);
                        loading(false);
                    });
            },
            onUsersFocus() {
                this.agents = [];
                this.filter.search = '';

                this.filter.province = this.expert2.province ? this.expert2.province : null;
                this.filter.region = null;

                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.agents = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            }
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>
    .btn-expert2 {
        background-color: #87CB16;
        border: 1px solid #87CB16;
        color: #FFFFFF;
        padding: 10px;
        border-radius: 5px;
        margin-bottom: 5px;
        margin-top: 5px;
        cursor: pointer;
        text-align: center;
        line-height: normal;
        position: relative;
        transition: inherit;
        align-items: center;
        text-transform: uppercase;
    }

    .btn-expert2 span {
        color: #fff;
        font-size: 14px;
    }

    .scroll {
        max-height: 600px;
        width: auto;
        overflow: scroll;
    }

    .check-blog .form-check-label {
        text-transform: uppercase;
        font-size: 12px;
    }
</style>